import produce from "immer"
import { ASC } from "const"
import { InferValueTypes } from "client/utils"
import { createProjectPermissions } from "client/store/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initProjectPermissionsState: types.ProjectPermissionsState = {
    projectPermissions: createProjectPermissions().permissionsSectioned,

    accountGroups: {
        groupIds: null,
        sortColumn: "name",
        sortOrder: ASC,
        filters: {
            search: null,
        },
        selected: null,
    },
    projectGroups: {
        groupIds: null,
        sortColumn: "name",
        sortOrder: ASC,
        filters: {
            search: null,
        },
        selected: null,
    },
    projectUsers: {
        userIds: null,
        sortColumn: "firstName",
        sortOrder: ASC,
        filters: {
            status: null,
            search: null,
        },
        selected: null,
    },

    reloadList: true,
}

const projectPermissionsReducer = produce((
    draft: types.ProjectPermissionsState = initProjectPermissionsState,
    action: ActionTypes = null,
): types.ProjectPermissionsState => {
    switch (action.type) {
        case types.SET_PROJECT_PERMISSIONS:
            draft.projectPermissions = action.projectPermissions
            return draft

        case types.UPDATE_PROJECT_PERMISSION: {
            const { section, permissionId, type, value } = action.data
            if (draft.projectPermissions[section]
                && draft.projectPermissions[section][permissionId]
                && draft.projectPermissions[section][permissionId][type] !== null) {
                draft.projectPermissions[section][permissionId][type] = value
            }
            return draft
        }

        case types.TOGGLE_PROJECT_PERMISSION_CUSTOMIZABLE: {
            const { section, permissionId } = action
            const permission = draft.projectPermissions[section] && draft.projectPermissions[section][permissionId]
                ? draft.projectPermissions[section][permissionId]
                : null
            if (permission) {
                draft.projectPermissions[section][permissionId].customizable = !permission.customizable
            }
            return draft
        }

        // not assigned account groups
        case types.PROJECT_PERMISSIONS_ACCOUNT_GROUP_IDS:
            draft.accountGroups.groupIds = action.groupIds
            return draft

        case types.PROJECT_PERMISSIONS_ACCOUNT_GROUP_SORT:
            draft.accountGroups.sortColumn = action.sortColumn
            draft.accountGroups.sortOrder = action.sortOrder
            return draft

        case types.PROJECT_PERMISSIONS_ACCOUNT_GROUP_FILTERS:
            draft.accountGroups.filters = action.filters
            return draft

        case types.PROJECT_PERMISSIONS_ACCOUNT_GROUP_SELECTED:
            draft.accountGroups.selected = action.selected
            return draft

        // not assigned project groups
        case types.PROJECT_PERMISSIONS_PROJECT_GROUP_IDS:
            draft.projectGroups.groupIds = action.groupIds
            return draft

        case types.PROJECT_PERMISSIONS_PROJECT_GROUP_SORT:
            draft.projectGroups.sortColumn = action.sortColumn
            draft.projectGroups.sortOrder = action.sortOrder
            return draft

        case types.PROJECT_PERMISSIONS_PROJECT_GROUP_FILTERS:
            draft.projectGroups.filters = action.filters
            return draft

        case types.PROJECT_PERMISSIONS_PROJECT_GROUP_SELECTED:
            draft.projectGroups.selected = action.selected
            return draft

        // not assigned project users
        case types.PROJECT_PERMISSIONS_PROJECT_USER_IDS:
            draft.projectUsers.userIds = action.userIds
            return draft

        case types.PROJECT_PERMISSIONS_PROJECT_USER_SORT:
            draft.projectUsers.sortColumn = action.sortColumn
            draft.projectUsers.sortOrder = action.sortOrder
            return draft

        case types.PROJECT_PERMISSIONS_PROJECT_USER_FILTERS:
            draft.projectUsers.filters = action.filters
            return draft

        case types.PROJECT_PERMISSIONS_PROJECT_USER_SELECTED:
            draft.projectUsers.selected = action.selected
            return draft

        // reload state
        case types.PROJECT_PERMISSIONS_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        default:
            return draft
    }
})
export default projectPermissionsReducer
